import React from 'react';
import { CheckIcon, StarIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { baseItems, baseUrl, premiumItems, premiumUrl } from '../data/offer';
type CheckLineProps = {
  children: React.ReactNode;
  premium?: boolean;
};
function CheckLine({
  children,
  premium = false
}: CheckLineProps) {
  return <li className="flex items-start gap-3 text-sm leading-snug text-muted" data-id="element-211" data-mp="1j9qoae3mxmfl">
      <CheckIcon className={`mt-0.5 h-5 w-5 shrink-0 ${premium ? 'text-alert' : 'text-teal'}`} data-id="element-212" data-mp="1nbbuxhpkt4hc" />
      {children}
    </li>;
}
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-white py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-213" data-mp="1x8zt6hme4u49">
      <div className="mx-auto max-w-5xl px-4" data-id="element-214" data-mp="228cq5v6z7hkk">
        <div className="text-center" data-id="element-215" data-mp="2271n5xlcudui">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-teal" data-id="element-216" data-mp="2uyupxur694p">Acceso inmediato</p>
          <h2 id="pricing-title" className="mt-3 text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-217" data-mp="7tifvw1ivgw0">Elegí tu Megapack</h2>
          <p className="mt-3 text-muted" data-id="element-218" data-mp="1mgy46xewhepi">Dos opciones · Mismo acceso inmediato</p>
        </div>

        <div className="mt-12 grid items-stretch gap-7 lg:grid-cols-2" data-id="element-219" data-mp="1hpoho5onerhu">
          <article className="flex flex-col rounded-3xl border border-line bg-mist p-6 text-ink shadow-card sm:p-8" data-id="element-220" data-mp="1cqv46d9d30ho">
            <p className="text-xs font-extrabold uppercase tracking-[.15em] text-muted" data-id="element-221" data-mp="17sacj286dp4u">Opción 1</p>
            <h3 className="mt-3 text-2xl font-bold" data-id="element-222" data-mp="25g2avziyywe0">Megapack Gestión Cultural Listo™</h3>
            <p className="mt-2 font-bold text-teal" data-id="element-223" data-mp="20gpfurhy2j0c">6 tomos + 4 bonos</p>
            <div className="mt-7" data-id="element-224" data-mp="20ed2ysr1myu5">
              <span className="text-sm text-muted line-through" data-id="element-225" data-mp="1vgtk1fjehxvv">$72.000 ARS</span>
              <p className="mt-1 font-display text-5xl font-extrabold text-petrol" data-id="element-226" data-mp="1rfri2qy3n7q7">
                $19.990 <small className="font-sans text-base" data-id="element-227" data-mp="k27nkuzk4zag">ARS</small>
              </p>
            </div>
            <ul className="mt-7 flex-1 space-y-3" data-id="element-228" data-mp="g0m5mv861ute">
              {baseItems.map(item => <CheckLine key={item} data-id="element-229" data-mp="g2ysnmss6vdb">{item}</CheckLine>)}
            </ul>
            <Button href={baseUrl} target="_blank" rel="noopener noreferrer" variant="petrol" arrow className="mt-8 w-full" data-id="element-230" data-mp="hforxifdvk3n">
              QUIERO MI MEGAPACK AHORA
            </Button>
          </article>

          <article className="relative flex flex-col rounded-3xl border-2 border-gold bg-mist p-6 text-ink shadow-lift sm:p-8" data-id="element-231" data-mp="7ly7comdntt8">
            <span className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-gold px-4 py-2 text-xs font-extrabold text-petrolDark shadow-lg" data-id="element-232" data-mp="3uw4n4pguielh">
              <StarIcon className="mr-1 inline h-3.5 w-3.5 fill-current" data-id="element-233" data-mp="3jtjk6im1rei" />
              MÁS ELEGIDO
            </span>
            <p className="mt-3 text-xs font-extrabold uppercase tracking-[.15em] text-muted" data-id="element-234" data-mp="3pxbh1i3w1pvc">Opción 2</p>
            <h3 className="mt-3 text-2xl font-bold" data-id="element-235" data-mp="3bxa77d5nb83q">Megapack + Upsell Premium</h3>
            <p className="mt-2 font-bold text-teal" data-id="element-236" data-mp="3fzducz1og14u">6 tomos + 4 bonos + 2 módulos avanzados</p>
            <div className="mt-7" data-id="element-237" data-mp="2xb3doznuynig">
              <span className="text-sm text-muted line-through" data-id="element-238" data-mp="2xabkfvhqh1vc">$110.000 ARS</span>
              <p className="mt-1 font-display text-5xl font-extrabold text-petrol" data-id="element-239" data-mp="2scjpstppf1ng">
                $27.990 <small className="font-sans text-base" data-id="element-240" data-mp="36bjhka8ijwnu">ARS</small>
              </p>
            </div>
            <ul className="mt-7 flex-1 space-y-3" data-id="element-241" data-mp="31cycnxibgot2">
              <CheckLine premium data-id="element-242" data-mp="31bdiwa3tt9w9">
                <b className="text-ink" data-id="element-243" data-mp="3g9z6q7nzcvup">Todo el Megapack base, más:</b>
              </CheckLine>
              {premiumItems.map(item => <CheckLine key={item} premium data-id="element-244" data-mp="3b9tdwo5z53b1">
                  <b className="font-semibold text-teal" data-id="element-245" data-mp="3b91ojv2z01t7">{item}</b>
                </CheckLine>)}
            </ul>
            <Button href={premiumUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full" data-id="element-246" data-mp="3l05u646raabd">
              QUIERO EL MEGAPACK + UPSELL PREMIUM
            </Button>
            <p className="mt-4 text-center text-xs text-muted" data-id="element-247" data-mp="3u1dt8oh3jf6i">
              Podés pagar con tarjeta de crédito o débito, transferencia bancaria o Mercado Pago en pesos argentinos.
            </p>
          </article>
        </div>
      </div>
    </section>;
}